module.exports = __webpack_public_path__ + "img/gallery_2.67f96967.jpg";